/**
 * Camera Attendance sidebar pages → permission mapping.
 * Register these strings in backend/RBAC.
 *
 * Sidebar module: HomePage.jsx — Camera Attendance
 */

export const CAMERA_ATTENDANCE_SCREEN_PERMISSION = 'camera_attendance.screen';

export const CAMERA_ATTENDANCE_ZONE_CONFIGS_LOCAL_PERMISSION =
  'camera_attendance.zone_configs_local';

/** Module visible when the user has any Camera Attendance page permission. */
export const CAMERA_ATTENDANCE_MODULE_PERMISSIONS = [
  CAMERA_ATTENDANCE_SCREEN_PERMISSION,
  CAMERA_ATTENDANCE_ZONE_CONFIGS_LOCAL_PERMISSION,
];
